var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-center",attrs:{"outlined":"","color":"transparent"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.spinner)}}),_c('v-card-text',{staticClass:"text-italic"},[_vm._t("content")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }